// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"c1778f60","453":"f16537cb","936":"ba61481d"}[chunkId] + ".chunk.js";
};